'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  width: ', ';\n'], ['\n  width: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n\n  & > div:first-child {\n    width: 700px;\n  }\n'], ['\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n\n  & > div:first-child {\n    width: 700px;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: center;\n  margin-bottom: 30px;\n  padding: 0 25px 30px 25px;\n  align-items: center;\n'], ['\n  display: flex;\n  justify-content: center;\n  margin-bottom: 30px;\n  padding: 0 25px 30px 25px;\n  align-items: center;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  width: 700px;\n  margin: 10px 0;\n  background: white;\n  padding: 30px 25px;\n  text-transform: uppercase;\n  font-weight: bold;\n  text-align: left;\n  box-sizing: border-box;\n  border: none;\n  border-radius: 5px;\n  font-family: \'Roboto Bold\';\n  font-size: 30px;\n  color: #444;\n  font-style: normal;\n  border: 1px solid #AAA;\n  overflow: hidden;\n\n  &.focused {\n    box-shadow: 0px 0px 5px grey;\n    border: 1px solid grey;\n    color: grey;\n  }\n'], ['\n  width: 700px;\n  margin: 10px 0;\n  background: white;\n  padding: 30px 25px;\n  text-transform: uppercase;\n  font-weight: bold;\n  text-align: left;\n  box-sizing: border-box;\n  border: none;\n  border-radius: 5px;\n  font-family: \'Roboto Bold\';\n  font-size: 30px;\n  color: #444;\n  font-style: normal;\n  border: 1px solid #AAA;\n  overflow: hidden;\n\n  &.focused {\n    box-shadow: 0px 0px 5px grey;\n    border: 1px solid grey;\n    color: grey;\n  }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  display: inline-block;\n  position: relative;\n  top: 9px;\n  left: 8px;\n  width: 5px;\n  height: 40px;\n  background: #777;\n\n  @keyframes blink {\n    0% { opacity: 1; }\n    50% { opacity: 0.1; }\n    100% { opacity: 1; }\n  }\n\n  animation-duration: 1.3s;\n  animation-iteration-count: infinite;\n  animation-name: blink;\n'], ['\n  display: inline-block;\n  position: relative;\n  top: 9px;\n  left: 8px;\n  width: 5px;\n  height: 40px;\n  background: #777;\n\n  @keyframes blink {\n    0% { opacity: 1; }\n    50% { opacity: 0.1; }\n    100% { opacity: 1; }\n  }\n\n  animation-duration: 1.3s;\n  animation-iteration-count: infinite;\n  animation-name: blink;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  opacity: 0.5;\n  display: inline-block;\n  margin-left: 15px;\n'], ['\n  opacity: 0.5;\n  display: inline-block;\n  margin-left: 15px;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  transition: opacity 0.4s;\n  text-transform: uppercase;\n  opacity: ', ';\n  margin: 10px;\n\n  & > div {\n    text-align: center;\n    background: ', ';\n    color: ', ';\n    padding: 30px 25px;\n    font-family: \'Roboto Bold\';\n    font-size: 45px;\n    cursor: pointer;\n    line-height: 48px;\n    border-radius: 10px;\n  }\n'], ['\n  transition: opacity 0.4s;\n  text-transform: uppercase;\n  opacity: ', ';\n  margin: 10px;\n\n  & > div {\n    text-align: center;\n    background: ', ';\n    color: ', ';\n    padding: 30px 25px;\n    font-family: \'Roboto Bold\';\n    font-size: 45px;\n    cursor: pointer;\n    line-height: 48px;\n    border-radius: 10px;\n  }\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  display: flex;\n  color: white;\n  font-family: \'Roboto\';\n  font-size: 25px;\n  padding: 25px 0;\n  text-transform: uppercase;\n\n  .terms {\n    text-decoration: underline;\n    padding-left: 10px;\n  }\n'], ['\n  display: flex;\n  color: white;\n  font-family: \'Roboto\';\n  font-size: 25px;\n  padding: 25px 0;\n  text-transform: uppercase;\n\n  .terms {\n    text-decoration: underline;\n    padding-left: 10px;\n  }\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  font-size: 25px;\n  color: white;\n  max-width: 700px;\n  padding-top: 50px;\n  font-family: Roboto;\n'], ['\n  font-size: 25px;\n  color: white;\n  max-width: 700px;\n  padding-top: 50px;\n  font-family: Roboto;\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n  width: 1em;\n  height: 1em;\n  box-sizing: border-box;\n  position: relative;\n  display: inline-block;\n  border: 0.15em solid white;\n  border-radius: 0.8em;\n  margin: 0 10px 0 0;\n  bottom: 2px;\n  background: ', ';\n'], ['\n  width: 1em;\n  height: 1em;\n  box-sizing: border-box;\n  position: relative;\n  display: inline-block;\n  border: 0.15em solid white;\n  border-radius: 0.8em;\n  margin: 0 10px 0 0;\n  bottom: 2px;\n  background: ', ';\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n  font-size: 25px;\n  color: white;\n  font-family: Roboto;\n  padding: 10px 0;\n  margin: -45px 0 20px 90px;\n'], ['\n  font-size: 25px;\n  color: white;\n  font-family: Roboto;\n  padding: 10px 0;\n  margin: -45px 0 20px 90px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _validator = require('validator');

var _validator2 = _interopRequireDefault(_validator);

var _doohUtils = require('dooh-utils');

var _Tap = require('../Tap');

var _Keyboard = require('./Keyboard');

var _Keyboard2 = _interopRequireDefault(_Keyboard);

var _Terms = require('./Terms');

var _Terms2 = _interopRequireDefault(_Terms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div(_templateObject, function (props) {
  return props.width || '1080px';
});

var ReviewWrapper = _styledComponents2.default.div(_templateObject2);

var InputWrapper = _styledComponents2.default.div(_templateObject3);

var Input = _styledComponents2.default.div(_templateObject4);

var Marker = _styledComponents2.default.div(_templateObject5);

var Suffix = _styledComponents2.default.div(_templateObject6);

var Button = _styledComponents2.default.div(_templateObject7, function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? 0.5 : 1;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.buttonBackgroundColor || '#FE0000';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.buttonTextColor || 'white';
});

var TermsLine = _styledComponents2.default.div(_templateObject8);

var Disclaimer = _styledComponents2.default.div(_templateObject9);

var Checkbox = _styledComponents2.default.div(_templateObject10, function (_ref4) {
  var selected = _ref4.selected;
  return selected ? 'red' : 'white';
});

// TODO style the form better (margin-left is a hack below)
var Over18 = _styledComponents2.default.div(_templateObject11);

var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form(props) {
    _classCallCheck(this, Form);

    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));

    _this.isOver18 = function (fieldValue) {
      if (fieldValue.length < 8) return false;
      var date = new Date(),
          todayDay = date.getDate(),
          todayMonth = date.getMonth() + 1,
          todayYear = date.getFullYear(),
          birthDay = parseInt(fieldValue.substr(0, 2), 10),
          birthMonth = parseInt(fieldValue.substr(2, 2), 10),
          birthYear = parseInt(fieldValue.substr(4, 4), 10);
      if (todayYear - birthYear > 18) return true;
      if (todayYear - birthYear < 18) return false;
      if (todayMonth > birthMonth) return true;
      if (todayMonth < birthMonth) return false;
      if (todayDay >= birthDay) return true;
      return false;
    };

    _this.getOver18Message = function (keyValue) {
      if (!_this.props.over18) return null;

      var s = _this.state,
          _this$getFieldOptions = _this.getFieldOptions(s.focus),
          type = _this$getFieldOptions.type,
          val = _this.state.values[s.focus] || '';


      if (type !== 'birth' || val.length !== 8) return null;

      return _this.isOver18(val) ? null : _react2.default.createElement(
        Over18,
        null,
        'Za sudjelovanje morate biti punoljetni'
      );
    };

    _this.isKeyEnabled = function (keyValue) {
      var s = _this.state,
          _this$getFieldOptions2 = _this.getFieldOptions(s.focus),
          type = _this$getFieldOptions2.type,
          val = _this.state.values[s.focus] || '',
          len = val.length,
          last = len > 0 ? val[len - 1] : null;


      if (type === 'birth') {
        if (keyValue === '.') {
          return len === 1 || len === 3;
        } else if (keyValue.match(/^[0-9]$/) != null) {
          switch (len) {
            case 0:
              return true;
            case 1:
              if (last === '0' && keyValue === '0') return false;
              if (last === '0' || last === '1' || last === '2') return true;
              return keyValue === '0' || keyValue === '1';
            case 2:
              return true;
            case 3:
              if (last === '0' && keyValue === '0') return false;
              if (last === '0') return true;
              return keyValue === '0' || keyValue === '1' || keyValue === '2';
            case 4:
              return keyValue === '1' || keyValue === '2';
            case 5:
              if (last === '1') return keyValue === '9';else return keyValue === '0';
            case 6:
              return true;
            case 7:
              return true;
            default:
              return false;
          }
        } else if (keyValue === 'backspace' && len > 0) {
          return true;
        } else if (keyValue === 'enter' && _this.isFieldValid(s.focus)) {
          return true;
        }
        return false;
      } else {
        return true;
      }
    };

    _this.getReviewField = function (field) {
      return _react2.default.createElement(
        _Tap.Tap,
        {
          key: field.name,
          onTap: function onTap() {
            return _this.setState({ focus: field.name, review: false });
          },
          preventDoubleTap: true
        },
        _react2.default.createElement(
          Input,
          null,
          _this.state.values[field.name] || '\xA0'
        )
      );
    };

    _this.isFieldValid = function (fieldName) {
      var value = (_this.state.values[fieldName] || '').trim();

      var _this$getFieldOptions3 = _this.getFieldOptions(fieldName),
          type = _this$getFieldOptions3.type;

      if (type === 'email') {
        return _validator2.default.isEmail(value);
      } else if (type === 'birth') {
        return value.length === 8 && (!_this.props.over18 || _this.isOver18(value));
      } else {
        return value.length > 0;
      }
    };

    _this.isValid = function () {
      return _this.state.acceptTerms && _this.props.fields.map(function (f) {
        return f.name;
      }).every(_this.isFieldValid);
    };

    _this.handleBirthKey = function (key) {
      var s = _this.state;
      var val = s.values[s.focus],
          len = val.length;

      if (len === 8 && key !== 'backspace' && key !== 'enter') return;

      if (key === '.') {

        if (len === 1) val = '0' + val;else if (len === 3) val = '' + val[0] + val[1] + '0' + val[2];
      } else if (key === 'backspace') {
        val = val.substr(0, val.length - 1);
      } else if (key === 'enter') {
        // TODO duplicated
        if (!_this.isFieldValid(s.focus)) return;

        var fields = _this.props.fields.map(function (f) {
          return f.name;
        }),
            index = (fields.indexOf(s.focus) + 1) % fields.length,
            field = fields[index];
        _this.setState({ focus: field, review: index === 0 });
        return;
      } else if (key.match(/^[0-9]$/) != null) {
        if (len === 0 && key.match(/[4-9]/) != null) {
          val += '0' + key;
        } else if (len === 2 && key.match(/[2-9]/) != null) {
          val += '0' + key;
        } else {
          val += key;
        }
      }

      _this.setState({ values: _extends({}, s.values, _defineProperty({}, s.focus, val)) });
    };

    _this.handleKey = function (key) {
      (0, _doohUtils.activity)();

      var s = _this.state,
          _this$getFieldOptions4 = _this.getFieldOptions(s.focus),
          type = _this$getFieldOptions4.type;


      if (type === 'birth') {
        _this.handleBirthKey(key);
        return;
      }

      var val = s.values[s.focus];

      if (key === 'space') {
        val = val + ' ';
      } else if (key === 'backspace') {
        val = val.substr(0, val.length - 1);
      } else if (key === 'enter') {
        if (!_this.isFieldValid(s.focus)) return;

        var fields = _this.props.fields.map(function (f) {
          return f.name;
        }),
            index = (fields.indexOf(s.focus) + 1) % fields.length,
            field = fields[index];
        _this.setState({ focus: field, review: index === 0 });
        return;
      } else if (val.length < 300) {
        val = val + key;
      }

      _this.setState({ values: _extends({}, s.values, _defineProperty({}, s.focus, val)) });
    };

    _this.handleSubmit = function () {
      if (_this.isValid()) _this.props.onSubmit(_this.state.values);
    };

    _this.toggleAcceptTerms = function () {
      _this.setState(function (s) {
        return _extends({}, s, { acceptTerms: !s.acceptTerms });
      });
    };

    _this.showTerms = function () {
      return _this.setState({ showTerms: true });
    };

    _this.hideTerms = function () {
      return _this.setState({ showTerms: false });
    };

    var values = {};
    props.fields.forEach(function (_ref5) {
      var name = _ref5.name;
      values[name] = '';
    });
    _this.state = {
      values: values,
      focus: props.fields[0].name,
      showTerms: false,
      acceptTerms: true,
      review: false
    };
    return _this;
  }

  _createClass(Form, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (this.state.review) {
        return _react2.default.createElement(
          ReviewWrapper,
          null,
          _react2.default.createElement(
            'div',
            null,
            this.props.fields.map(this.getReviewField),
            this.props.terms && _react2.default.createElement(
              TermsLine,
              null,
              _react2.default.createElement(
                _Tap.Tap,
                {
                  onTap: this.toggleAcceptTerms,
                  preventDoubleTap: false
                },
                _react2.default.createElement(Checkbox, { selected: this.state.acceptTerms })
              ),
              _react2.default.createElement(
                _Tap.Tap,
                {
                  onTap: this.toggleAcceptTerms,
                  preventDoubleTap: false
                },
                'Sla\u017Eem se s'
              ),
              _react2.default.createElement(
                _Tap.Tap,
                { className: 'terms', onTap: this.showTerms, preventDoubleTap: false },
                'pravilima natje\u010Daja'
              )
            ),
            _react2.default.createElement(
              Button,
              { className: 'Button', disabled: !this.isValid() },
              _react2.default.createElement(
                _Tap.Tap,
                { onTap: this.handleSubmit, preventDoubleTap: true },
                'Po\u0161alji'
              )
            )
          ),
          this.state.showTerms && _react2.default.createElement(_Terms2.default, { terms: this.props.terms, onClose: this.hideTerms }),
          this.props.disclaimer && _react2.default.createElement(
            Disclaimer,
            null,
            this.props.disclaimer
          )
        );
      } else {
        return _react2.default.createElement(
          Wrapper,
          null,
          _react2.default.createElement(
            InputWrapper,
            null,
            _react2.default.createElement(
              Input,
              null,
              this.getShowValue(),
              _react2.default.createElement(Marker, null),
              _react2.default.createElement(
                Suffix,
                null,
                this.getSuffix()
              )
            ),
            _react2.default.createElement(
              Button,
              { className: 'Button', disabled: !this.isFieldValid(this.state.focus) },
              _react2.default.createElement(
                _Tap.Tap,
                {
                  onTap: function onTap() {
                    return _this2.handleKey('enter');
                  },
                  preventDoubleTap: false
                },
                'Dalje'
              )
            )
          ),
          this.getOver18Message(),
          _react2.default.createElement(_Keyboard2.default, {
            layout: this.getKeyboardLayout(),
            onKey: this.handleKey,
            isKeyEnabled: this.isKeyEnabled
          })
        );
      }
    }
  }, {
    key: 'getKeyboardLayout',
    value: function getKeyboardLayout() {
      var _getFieldOptions = this.getFieldOptions(this.state.focus),
          type = _getFieldOptions.type;

      switch (type) {
        case 'name':
          return _Keyboard.NAME_LAYOUT;
        case 'phone':
          return _Keyboard.NUM_LAYOUT;
        case 'birth':
          return _Keyboard.BIRTH_LAYOUT;
        case 'email':
          var splitName = this.state.values.name.split(' '),
              // TODO find values with type name
          firstName = splitName[0],
              lastName = splitName[1];
          var specKeys = "@_+".split('').map(function (k) {
            return { label: k, value: k };
          });

          var isValid = function isValid(value) {
            return value && value.length > 1 && value.length < 10 && value !== 'enter' && value !== 'space' && value !== 'backspace';
          };

          if (isValid(firstName)) {
            specKeys.push({
              label: firstName,
              value: firstName,
              className: 'small'
            });
          }

          if (isValid(lastName)) {
            specKeys.push({
              label: '.',
              value: '.'
            });
            specKeys.push({
              label: lastName,
              value: lastName,
              className: 'small'
            });
          }

          specKeys.push({ value: '@gmail.com', label: '@gmail.com', className: 'small' }, { value: '.com', label: '.com', className: 'small' });

          return [{
            groupName: 'emailSpecial',
            keys: specKeys
          }].concat(_toConsumableArray(_Keyboard.HR_LAYOUT));
        default:
          return _Keyboard.HR_LAYOUT;
      }
    }
  }, {
    key: 'getShowValue',
    value: function getShowValue() {
      var s = this.state,
          _getFieldOptions2 = this.getFieldOptions(s.focus),
          type = _getFieldOptions2.type,
          label = _getFieldOptions2.label;


      if (type === 'birth') {
        var value = s.values[s.focus] || '',
            show = [function (s) {
          return '' + label;
        }, function (s) {
          return '' + s[0];
        }, function (s) {
          return '' + s[0] + s[1] + '.';
        }, function (s) {
          return '' + s[0] + s[1] + '.' + s[2];
        }, function (s) {
          return '' + s[0] + s[1] + '.' + s[2] + s[3] + '.';
        }, function (s) {
          return '' + s[0] + s[1] + '.' + s[2] + s[3] + '.' + s[4];
        }, function (s) {
          return '' + s[0] + s[1] + '.' + s[2] + s[3] + '.' + s[4] + s[5];
        }, function (s) {
          return '' + s[0] + s[1] + '.' + s[2] + s[3] + '.' + s[4] + s[5] + s[6];
        }, function (s) {
          return '' + s[0] + s[1] + '.' + s[2] + s[3] + '.' + s[4] + s[5] + s[6] + s[7] + '.';
        }];
        return show[value.length](value);
      } else {
        return s.values[s.focus] || label;
      }
    }
  }, {
    key: 'getSuffix',
    value: function getSuffix() {
      var _getFieldOptions3 = this.getFieldOptions(this.state.focus),
          type = _getFieldOptions3.type,
          value = this.state.values[this.state.focus] || '',
          birthSuffixes = ['', 'd.mm.gggg.', 'mm.gggg.', 'm.gggg.', 'gggg.', 'ggg.', 'gg.', 'g.', ''];

      if (type === 'birth') {
        return birthSuffixes[value.length];
      } else {
        return '';
      }
    }
  }, {
    key: 'getFieldOptions',
    value: function getFieldOptions(field) {
      return this.props.fields.find(function (f) {
        return f.name === field;
      });
    }
  }]);

  return Form;
}(_react2.default.Component);

Form.defaultProps = {
  over18: false
};
exports.default = Form;


//////////////////
// WEBPACK FOOTER
// ./~/dooh-react-utils/dist/form/Form.js
// module id = 138
// module chunks = 0